import React from "react";

const Calendar = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#F6F8FA" />
      <path
        d="M23.75 13.25H26.75C26.9489 13.25 27.1397 13.329 27.2803 13.4697C27.421 13.6103 27.5 13.8011 27.5 14V26C27.5 26.1989 27.421 26.3897 27.2803 26.5303C27.1397 26.671 26.9489 26.75 26.75 26.75H13.25C13.0511 26.75 12.8603 26.671 12.7197 26.5303C12.579 26.3897 12.5 26.1989 12.5 26V14C12.5 13.8011 12.579 13.6103 12.7197 13.4697C12.8603 13.329 13.0511 13.25 13.25 13.25H16.25V11.75H17.75V13.25H22.25V11.75H23.75V13.25ZM26 19.25H14V25.25H26V19.25ZM22.25 14.75H17.75V16.25H16.25V14.75H14V17.75H26V14.75H23.75V16.25H22.25V14.75ZM15.5 20.75H17V22.25H15.5V20.75ZM19.25 20.75H20.75V22.25H19.25V20.75ZM23 20.75H24.5V22.25H23V20.75Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default Calendar;
